/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Thu Jun 6 2019 3:16:54 PM
 *
 *******************************************************/
//@flow
import _ from 'lodash';
import React, { Component } from 'react';
import { TextContainer, Card, TextStyle } from '@shopify/polaris';
import history from 'src/routes/history';
import { connect } from 'react-redux';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

type Props = {
  emailSupport: string
};

type ComposedProps = Props & WithI18nProps;

class AfterSubmit extends Component<ComposedProps> {
  render() {
    const { i18n, emailSupport } = this.props;

    return (
      <Card
        sectioned
        title={i18n.translate('AdminHTML.ThemeUpgrade.VerifyUpgrade.afterSubmit_Title')}
        primaryFooterAction={{
          content: i18n.translate(
            'AdminHTML.ThemeUpgrade.VerifyUpgrade.afterSubmit_ActionGoToHome'
          ),
          onAction: () => this.toHomepage()
        }}>
        <TextContainer>
          <p>
            {i18n.translate('AdminHTML.ThemeUpgrade.VerifyUpgrade.afterSubmit_Content', {
              nt_email: <TextStyle variation="strong">{emailSupport}</TextStyle>
            })}
          </p>
        </TextContainer>
      </Card>
    );
  }

  toHomepage() {
    history.push('/');
  }
}
const mapStateToProps = (state, props) => ({
  emailSupport: _.get(state.oauth, 'emailSupport')
});

export default connect(
  mapStateToProps,
  {}
)(withI18n()(AfterSubmit));
